import { Link } from 'react-router-dom';
import { Button } from '@dreamtree-org/twreact-ui';

export default function NotFound() {
  return (
    <div className="min-h-dvh flex flex-col items-center justify-center gap-4 p-6 text-center bg-[var(--app-bg)]">
      <div className="text-5xl font-bold text-primary-600">404</div>
      <p className="text-secondary-500">This page doesn’t exist.</p>
      <Link to="/"><Button variant="outline">Back to dashboard</Button></Link>
    </div>
  );
}
